import { DASH_META_ROOT } from './auth';

export const dashMetaLogout = async () => {
  try {
    await fetch(`${DASH_META_ROOT}/api/auth/logout?types="storage"`, {
      credentials: 'include',
      headers: { 'request-id': crypto.randomUUID() },
    });
  } catch (err) {
    console.error('DASH_META_LOGOUT', err);
    throw err;
  }
};
